
export class Questions {

  //Most of the fields corresponds to  the values in json
  Qn: string;
  S_Qn: string;
  Qn_Num: number;//1,1.1,2,2.1...
  Qn_In: string;//1,2,3,4,5,6,7,8...
  Qn_Type: string;//checkbox,radio,subjective...
  Qn_Deps: [number];//question is a dependent question. Only for radio and checkboxes type. Questions gets open upon clicking options
  Qn_Parent: number;//not getting used
  Opt_Dep: [number]; //Checking if current question is option dependent //If it is then we need to check if its options criteria is satisfied to decide whether to show it or not
  Age_Range: [number];
  Repeater: boolean;//if question is of repeater type. Repeater Dialog gets open upon filling the ans of this question and press proceed
  Qn_Repeat: [number];//question number of questions that are getting repeated if this question has repeater true
  Opt_Name: [string];
  S_Opt_Name: [string];
  Is_Mandt: boolean;
  Is_Range: boolean;
  Is_Cond: boolean;
  Repeat_Dependence: number;//not getting used. Instead Parent_Repeat is used now
  Min_Char: number;
  Max_Char: number;
  IS_Anomaly: boolean;
  is_double_dependent : boolean;


  //New field to save user respond
  //Only numerical results are necessary for current app
  user_Res : string[];

  //To track whether current question is visible to user
  is_Visible : boolean;

  //Display value from left panel
  Qn_Disp_Value : string;


  //Display SubQuestions
  Is_Sub_Visible : boolean;


  //New parents type
  Parent_Age : number;
  Parent_Dep : number;// Linked to Opt_Dep. If this questions parent has not received a user response then it will straight a way not shown //So it checks if its parent has a user response
  Parent_Repeat : number;//If Parent_Repeat is not null then question should be shown in repeater dialog box and not in normal flow

  //It stores the main parent value according to questions in central panel
  //Example : 1  for sub questions 1.1, 1.2 , 1.1.1 etc.

  Is_Age_Parent : boolean;


}



// WEBPACK FOOTER //
// ./src/app/classes/question.ts